import React, { Component } from 'react';

import Uuid from '../../../../../support/Uuid';
import CartaPorteTiposFiguraParteTransporteList from './CartaPorteTiposFiguraParteTransporteList';
import CartaPorteTiposFiguraPartesTransporteForm from './CartaPorteTiposFiguraPartesTransporteForm';

class CartaPorteTiposFiguraPartesTransporteManager extends Component {

  state = {}

  handleOnAdd = (data) => {
    const { PartesTransporte = [] } = this.props.data;

    const newData = PartesTransporte.concat([{
      id: Uuid.v4(),
      ...data
    }]);

    this.handleOnListChange(newData);
  }

  handleOnListChange = (data) => {
    const newData = {
      PartesTransporte: data
    }

    this.props.onChange(newData);
  }

  handleOnEdit = (item) => {
    this.setState({
      data: { ...item }
    }, () => {
      this.setState({
        data: undefined
      });
    });
  }

  render() {
    const { data } = this.state;
    const { PartesTransporte = [] } = this.props.data;

    return (
      <>
        <fieldset>
          <legend>Partes Transporte</legend>

          <CartaPorteTiposFiguraPartesTransporteForm
            data={ data }
            onAdd={ this.handleOnAdd }
          />

          <CartaPorteTiposFiguraParteTransporteList
            data={ PartesTransporte }
            onEdit={ this.handleOnEdit }
            onChange={ this.handleOnListChange }
          />
        </fieldset>
      </>
    )
  }
}

export default CartaPorteTiposFiguraPartesTransporteManager;